<template>
  <div ref="customCursor" class="fancy mb-flexMobile h-auto montserrat container mx-auto w-full flex justify-center items-center">
    <div ref="cardsContainer" class="relative flex justify-center items-center bg-center overflow-hidden">
      <!-- Cards -->
      <div class="relative flex w-full justify-center items-center gap-6">
        <div
          v-for="(image, index) in images"
          :key="index"
          :class="`card-container w-full md:w-[45%] relative hover-trigger transition-transform duration-500 ease-in-out ${index ? `top` :``}`"
        >
          <router-link :to="image.link" class="block h-full">
            <!-- Main Image -->
            <img
              :src="image.src"
              :alt="image.alt"
              class="w-full h-[500px] object-cover rounded-lg shadow-lg card-image"
            />
            <!-- Hover Image -->
            <div class="hover-image-container">
              <img
                v-if="image.hoverSrc"
                :src="image.hoverSrc"
                :alt="`${image.alt} hover`"
                class="hover-image"
              />
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FullWidthCards',
  data() {
    return {
      images: [
        {
          src: "https://res.cloudinary.com/dvkj5orhe/image/upload/v1732244965/lhuviesu2ayejh0olnuc.png",
          hoverSrc: "https://res.cloudinary.com/dvkj5orhe/image/upload/v1732244965/tkl3hlewo3hxwpaehybi.png",
          alt: "Group 5",
          link: '/FirstProjectWork',
        },
        {
          src: "https://res.cloudinary.com/dvkj5orhe/image/upload/v1732244965/agyqeumsqbf9luqfmsng.png",
          hoverSrc: "https://res.cloudinary.com/dvkj5orhe/image/upload/v1732244965/vcpl2ykiky0vwsn7czxw.png",
          alt: "Group 6",
          link: '/SubscriptionManagement',
        },
      ],
    };
  },
};
</script>
<!-- <style>
.card-container {
  position: relative;
  flex: 1;
  transition: transform 0.3s ease-in-out, flex 0.3s ease-in-out;
}

.card-container:hover {
  transform: scale(1.1); /* Enlarge hovered card */
  flex: 1.5; /* Slightly larger space */
}

.card-container:not(:hover) {
  transform: scale(0.9); /* Shrink non-hovered cards */
  flex: 0.5; /* Slightly smaller space */
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  transition: opacity 0.3s ease-in-out; /* Smooth fade-out effect */
  z-index: 1; /* Ensure it stays below the hover image */
}

.card-container:hover .card-image {
  opacity: 0; /* Hide unhovered image */
}

.hover-image-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.6);
  width: 10%;
  height: 120%;
  opacity: 0;
  z-index: 10; /* Ensure it's above the original image */
  overflow: hidden;
  transition: all 0.5s ease-in-out;
}

.hover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-container:hover .hover-image-container {
  opacity: 1; /* Show hover image */
  transform: translate(-50%, -50%) scale(10.5);
}

/* Mobile styles */
@media (max-width: 768px) {
  .card-container {
    flex: 1;
    transform: none !important;
  }

  .card-container:hover {
    transform: none !important;
    flex: 1;
  }

  .card-image,
  .hover-image-container {
    opacity: 1 !important; /* Always visible on mobile */
  }
}


</style> -->